import type { CheckboxProps } from "@radix-ui/react-checkbox";

import { Checkbox } from "@/components/ui/checkbox";

export interface CheckboxCustomProps extends CheckboxProps {
  id?: string;
  label: string;
}

const CheckboxCustom = ({ id, label, ...props }: CheckboxCustomProps) => {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox id={id} aria-label={label} {...props} />
      <label className="text-sm text-gray-700 cursor-pointer" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default CheckboxCustom;
